import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const GitlabAiAccesses = {
  permission: Access({
    description:
      "Roles on GitLab projects, granted via a per-grant service account",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      group: {
        type: "dynamic",
        label: "Group",
        description: "GitLab top-level group",
      },
      // Encoded as "<project path>:<role>" (e.g. "acme/app:developer"); see
      // GitlabRoles for the roles.
      policies: {
        type: "dynamic",
        label: "Projects",
        description: "Projects and the role to grant on each",
        multivalued: true,
      },
    },
    render: {
      locator: "group",
      policy: "policies",
    } as const,
  }),
};

export type GitlabAiAccesses = typeof GitlabAiAccesses;
export type GitlabAiAccess = GitlabAiAccesses[keyof GitlabAiAccesses];
export type GitlabAiPermissionAccess = GitlabAiAccesses["permission"];
